export { GlobalStyle } from 'config/globalStyles';